(function () {
  'use strict';

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function parseProduct(raw) {
    if (!raw) {
      return null;
    }

    if (typeof raw === 'object') {
      return raw;
    }

    try {
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  function escapeAttr(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;');
  }

  function normalizeImageUrl(url) {
    if (!url || url === 'null' || url === 'undefined') {
      return '';
    }

    var normalized = String(url).trim();

    if (normalized.indexOf('//') === 0) {
      normalized = 'https:' + normalized;
    }

    if (normalized.indexOf('{width}') !== -1) {
      normalized = normalized.replace(/\{width\}/g, '360');
    }

    return normalized;
  }

  function resizeImageUrl(url) {
    var normalized = normalizeImageUrl(url);

    if (!normalized) {
      return '';
    }

    if (window.theme && theme.Images && typeof theme.Images.getSizedImageUrl === 'function') {
      var sized = theme.Images.getSizedImageUrl(normalized, '360x360');

      if (sized) {
        return normalizeImageUrl(sized);
      }
    }

    var sizedMatch = normalized.match(/(\.(jpg|jpeg|gif|png|webp|bmp|bitmap|tiff|tif|heic|avif))(\?v=\d+)?$/i);

    if (sizedMatch && normalized.indexOf('_360x360') === -1) {
      return normalized.replace(
        /(\.(jpg|jpeg|gif|png|webp|bmp|bitmap|tiff|tif|heic|avif))(\?v=\d+)?$/i,
        '_360x360$1$3'
      );
    }

    return normalized;
  }

  function pickImageSource(product) {
    var candidates = [];

    if (product.featured_image) {
      candidates.push(
        typeof product.featured_image === 'string'
          ? product.featured_image
          : product.featured_image.src || product.featured_image.url || ''
      );
    }

    if (product.images && product.images.length) {
      product.images.forEach(function (image) {
        if (typeof image === 'string') {
          candidates.push(image);
        } else {
          candidates.push(image.src || image.url || '');
        }
      });
    }

    if (product.image) {
      candidates.push(typeof product.image === 'string' ? product.image : product.image.src || '');
    }

    if (product.media && product.media.length) {
      product.media.forEach(function (item) {
        if (item.preview_image && item.preview_image.src) {
          candidates.push(item.preview_image.src);
        }
      });
    }

    if (product.image_responsive_url) {
      candidates.push(product.image_responsive_url);
    }

    var i;
    for (i = 0; i < candidates.length; i++) {
      var candidate = normalizeImageUrl(candidates[i]);
      if (candidate && candidate.indexOf('{width}') === -1) {
        return resizeImageUrl(candidate);
      }
    }

    for (i = 0; i < candidates.length; i++) {
      var lazyCandidate = resizeImageUrl(candidates[i]);
      if (lazyCandidate) {
        return lazyCandidate;
      }
    }

    return '';
  }

  function getPrimaryVariant(product) {
    if (!product.variants || !product.variants.length) {
      return null;
    }

    var available = product.variants.find(function (variant) {
      return variant.available;
    });

    return available || product.variants[0];
  }

  function getImageUrl(product) {
    return pickImageSource(product);
  }

  function getBadges(product, variant) {
    var badges = [];
    var tags = product.tags || [];
    var tagsJoined = tags.join(',').toLowerCase();
    var price = variant ? variant.price : 0;
    var compareAt = variant ? variant.compare_at_price : null;
    var onSale = compareAt && compareAt > price;

    if (onSale) {
      badges.push({ type: 'sale', label: 'Promocja' });
    }

    var hasNew = tags.some(function (tag) {
      var normalized = String(tag).trim().toLowerCase();
      return normalized === 'nowosc' || normalized === 'nowość' || normalized.indexOf('nowo') === 0;
    });

    if (!hasNew && (tagsJoined.indexOf('nowosc') !== -1 || tagsJoined.indexOf('nowość') !== -1)) {
      hasNew = true;
    }

    if (hasNew) {
      badges.push({ type: 'new', label: 'Nowość' });
    }

    if (tagsJoined.indexOf('bestseller') !== -1) {
      badges.push({ type: 'bestseller', label: 'Bestseller' });
    }

    return badges;
  }

  function buildCard(product) {
    var variant = getPrimaryVariant(product);
    var badges = getBadges(product, variant);
    var price = variant ? variant.price : 0;
    var compareAt = variant ? variant.compare_at_price : null;
    var available = product.available !== false && (!variant || variant.available);
    var imgUrl = getImageUrl(product);

    var badgesHtml = badges
      .map(function (badge) {
        return (
          '<span class="loanti-recently-viewed-card__badge loanti-recently-viewed-card__badge--' +
          badge.type +
          '">' +
          badge.label +
          '</span>'
        );
      })
      .join('');

    var compareHtml = '';
    if (compareAt && compareAt > price) {
      compareHtml =
        '<span class="loanti-recently-viewed-card__compare">' + formatMoney(compareAt) + '</span>';
    }

    var statusHtml = available
      ? '<p class="loanti-recently-viewed-card__status"><span class="loanti-stock-dot" aria-hidden="true"></span> Dostępny</p>'
      : '<p class="loanti-recently-viewed-card__status loanti-recently-viewed-card__status--soldout">Niedostępny</p>';

    return (
      '<article class="loanti-recently-viewed-card">' +
      '<a href="' +
      product.url +
      '" class="loanti-recently-viewed-card__media">' +
      (badgesHtml ? '<div class="loanti-recently-viewed-card__badges">' + badgesHtml + '</div>' : '') +
      '<img src="' +
      escapeAttr(imgUrl) +
      '" alt="' +
      escapeHtml(product.title) +
      '" loading="lazy" width="180" height="180">' +
      '</a>' +
      '<div class="loanti-recently-viewed-card__body">' +
      '<a href="' +
      product.url +
      '" class="loanti-recently-viewed-card__name">' +
      escapeHtml(product.title) +
      '</a>' +
      statusHtml +
      '<div class="loanti-recently-viewed-card__prices">' +
      '<span class="loanti-recently-viewed-card__price">' +
      formatMoney(price) +
      '</span>' +
      compareHtml +
      '</div>' +
      '</div>' +
      '</article>'
    );
  }

  function bindCarousel(container) {
    if (!container || container.getAttribute('data-loanti-recent-bound') === '1') {
      return;
    }

    container.setAttribute('data-loanti-recent-bound', '1');

    container.querySelectorAll('[data-loanti-recent-prev], [data-loanti-recent-next]').forEach(function (button) {
      button.addEventListener('click', function () {
        var targetId =
          button.getAttribute('data-loanti-recent-prev') || button.getAttribute('data-loanti-recent-next');
        var track = document.getElementById(targetId);
        if (!track) {
          return;
        }

        var direction = button.hasAttribute('data-loanti-recent-prev') ? -1 : 1;
        track.scrollBy({
          left: direction * Math.max(track.clientWidth * 0.75, 180),
          behavior: 'smooth'
        });
      });
    });
  }

  function patchRecentlyViewed() {
    if (!window.theme || !theme.RecentlyViewed || !theme.RecentlyViewed.prototype) {
      return;
    }

    var originalSetup = theme.RecentlyViewed.prototype.setupOutput;

    theme.RecentlyViewed.prototype.setupOutput = function (products) {
      var listEl =
        this.outputContainer && this.outputContainer.querySelector('.loanti-recently-viewed__list');

      if (!listEl) {
        return originalSetup.call(this, products);
      }

      var allProducts = [];
      var limit = parseInt(this.container.getAttribute('data-recent-count'), 10) || 5;

      Object.keys(products).forEach(
        function (key) {
          if (!products[key]) {
            return;
          }

          var product = parseProduct(products[key]);

          if (!product || product.handle === this.handle || typeof product.handle === 'undefined') {
            return;
          }

          product.url = theme.recentlyViewed.recent[product.handle]
            ? theme.recentlyViewed.recent[product.handle].url
            : product.url;

          var recentMeta = theme.recentlyViewed.recent[product.handle];
          if (recentMeta && recentMeta.featuredImage) {
            var storedImage = String(recentMeta.featuredImage);
            if (storedImage.indexOf('{width}') === -1) {
              product.image_responsive_url = storedImage;
            }
          }

          allProducts.unshift(product);
        }.bind(this)
      );

      if (allProducts.length === 0) {
        this.container.classList.add('hide');
        return;
      }

      this.container.classList.remove('hide');
      listEl.innerHTML = allProducts
        .slice(0, limit)
        .map(buildCard)
        .join('');

      bindCarousel(this.container);
    };
  }

  patchRecentlyViewed();
})();
